<div *ngIf="galleries.length>0" [@loadedHeightAnimation]="'visible'" class="cont__gallery">
  <ng-container *ngFor="let item of galleries">
    <div *ngIf="item.GalleryType == 'IMAGEN'" class="simply_card">
      <div class="card">
        <div class="card-img-top">
          <img *ngIf="item.ImageFile" alt="{{item.Title}}" [src]="item.ImageFile.FileUri" class="img-fluid">
        </div>
        <div class="card-title">
          <h6 class="title">{{item.Title}}</h6>
        </div>
        <div class="card-body min-height-120">
          <div class="body-content">
            <div>
              <div class="date" *ngIf="item.ShowDate">{{item.ElementDate | date: 'dd/MM/yyyy'}}</div>
              <p class="card-text" *ngIf="item.ShowDescription">
                {{item.Description}}
              </p>
            </div>
            <a *ngIf="item.Url!=null && item.Url!=''" (click)="openLink(item)" class="link-card">Link</a>
          </div>
        </div>
        <div class="card-footer">
          <div class="footer-buttons">
            <a (click)="PostLog(item.IdGalleryData)" [href]="item.File.FileUri" class="btn-orange-border btn-icon" *ngIf="item.ShowDownloadButton">
              <div class="svg-icon"><svg viewBox="0 0 150 150">
                  <use xlink:href="assets/images/icons/ico_download_auto.svg#img"
                    href="assets/images/icons/ico_download_auto.svg#img"></use>
                </svg></div> Download
            </a>
            <a *ngIf="item.View" type="button" (click)="downloadFileView(item.File,true)"
              class="btn-orange-border btn-icon">
              <div class="svg-icon mb-1"><svg viewBox="0 0 150 150">
                  <use xlink:href="assets/images/icons/ico_eye_auto.svg#img"
                    href="assets/images/icons/ico_eye_auto.svg#img"></use>
                </svg></div> VER
            </a>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="item.GalleryType == 'VIDEO'" class="simply_card">
      <div class="card">
        <div class="card-img-top">
          <video [poster]="item.ImageFile != null ? item.ImageFile.FileUri : null " controls preload="metadata"
            title="{{item.ImageFile != null ? item.ImageFile.FileName : null}}">
            <source [src]="pathVideo + 'GalleryData/' + item.File.BlobFileName | addtoken | async" type="video/mp4">
          </video>
        </div>
        <div class="card-title">
          <h6 class="title">{{item.Title}}</h6>
        </div>
        <div class="card-body min-height-120">
          <div class="body-content">
            <div class="date" *ngIf="item.ShowDate">{{item.ElementDate | date: 'dd/MM/yyyy'}}</div>
            <p class="card-text" *ngIf="item.ShowDescription">
              {{item.Description}}
            </p>
          </div>
        </div>
        <div class="card-footer">
          <div class="footer-buttons">
            <a [href]="item.File.FileUri" (click)="PostLog(item.IdGalleryData)" class="btn-orange-border btn-icon" *ngIf="item.ShowDownloadButton">
              <div class="svg-icon"><svg viewBox="0 0 150 150">
                  <use xlink:href="assets/images/icons/ico_download_auto.svg#img"
                    href="assets/images/icons/ico_download_auto.svg#img"></use>
                </svg></div> Download
            </a>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="item.GalleryType == 'AUDIO'" class="simply_card">
      <div class="card">
        <div class="card-img-top">
          <img *ngIf="item.ImageFile" alt="{{item.Title}}" [src]="item.ImageFile.FileUri">
        </div>
        <div class="card-title">
          <h6 class="title">{{item.Title}}</h6>
        </div>
        <div class="card-body min-height-120">
          <div class="body-content">
            <div class="date" *ngIf="item.ShowDate">{{item.ElementDate | date: 'dd/MM/yyyy'}}</div>
            <p class="card-text" *ngIf="item.ShowDescription">
              {{item.Description}}
            </p>
            <audio controls class="w-100 mt-3">
              <source [src]="item.File.FileUri | addtoken | async" type="audio/mpeg">
            </audio>
          </div>
        </div>
        <div class="card-footer">
          <div class="footer-buttons">
            <a [href]="item.File.FileUri" (click)="PostLog(item.IdGalleryData)" class=" btn-orange-border btn-icon" *ngIf="item.ShowDownloadButton">
              <div class="svg-icon"><svg viewBox="0 0 150 150">
                  <use xlink:href="assets/images/icons/ico_download_auto.svg#img"
                    href="assets/images/icons/ico_download_auto.svg#img"></use>
                </svg></div> Download
            </a>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>